<template>
	<div class="text-justify">
		<div class="row">
			<!-- Invoice History Table -->
			<div class="col-md-12">
				<lead-profile-tab-finance-invoice-history-table :value=value></lead-profile-tab-finance-invoice-history-table>
			</div>

			<!-- Invoice Request Form -->
			<!-- <div class="col-lg-12 mt-8">
				<div class="mb-4">
					<h4>Invoice Request</h4>
					<hr
						style="border-top: 2px solid black; font-weight: bold"
					/>
				</div>
				<form
					ref="form"
					data-url=""
					class="mb-0"
					@submit.prevent="submitInvoiceRequest"
				>
					<div class="row">
						<div class="col-lg-12">
							<div class="row">
								<div class="col-md-3">
									<div class="form-group">
										<label>Reference ID</label>
										<input
											type="text"
											placeholder="Reference ID"
											v-model="
												invoiceRequest.reference_id
											"
											name="reference_id"
											class="form-control"
										/>
									</div>
								</div>

								<div class="col-md-3">
									<div class="form-group">
										<label>Request Date</label>
										<app-input
											type="date"
											v-model="
												invoiceRequest.request_date
											"
											name="request_date"
											placeholder="Request Date"
										/>
									</div>
								</div>

								<div class="col-md-3">
									<div class="form-group">
										<label
											>Invoice Send To
											<span class="required-star"
												>*</span
											></label
										>
										<input
											type="text"
											placeholder="Invoice Send To"
											v-model="
												invoiceRequest.invoice_send_to
											"
											name="invoice_send_to"
											class="form-control"
											required
										/>
									</div>
								</div>

								<div class="col-md-3">
									<div class="form-group">
										<label>Scheduled Print Date</label>
										<app-input
											type="date"
											v-model="
												invoiceRequest.scheduled_print_date
											"
											name="scheduled_print_date"
											placeholder="Scheduled Print Date"
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-3">
									<div class="form-group">
										<label>Invoice Request No</label>
										<input
											type="text"
											placeholder="Invoice Request No"
											v-model="
												invoiceRequest.invoice_request_no
											"
											name="invoice_request_no"
											class="form-control"
										/>
									</div>
								</div>

								<div class="col-md-3">
									<div class="form-group">
										<label>Requested By</label>
										<input
											type="text"
											placeholder="Requested By"
											v-model="
												invoiceRequest.requested_by
											"
											name="requested_by"
											class="form-control"
										/>
									</div>
								</div>

								<div class="col-md-3">
									<div class="form-group">
										<label
											>Invoice Send Via
											<span class="required-star"
												>*</span
											></label
										>
										<app-input
											placeholder="Invoice Send Via"
											type="search-select"
											:list="invoice_sent_vias"
											name="invoice_sent_via"
											v-model="
												invoiceRequest.invoice_send_via
											"
											required
										/>
									</div>
								</div>

								<div class="col-md-3">
									<div class="form-group">
										<label
											>Invoice Due Date
											<span class="required-star"
												>*</span
											></label
										>
										<app-input
											type="date"
											v-model="invoiceRequest.invoice_due_date"
											name="due_date"
											placeholder="Invoice Due Date"
											required
										/>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="mt-5 mb-5 action-buttons">
						<button type="submit" class="btn btn-primary mr-2">
							Submit
						</button>
						<button
							type="button"
							class="btn btn-secondary"
							@click="clearInvoiceRequest"
						>
							Clear
						</button>
					</div>
				</form>
			</div> -->

			<!-- Study Information Table -->
			<!-- <div class="col-md-12 mt-8">
				<lead-profile-tab-finance-study-information-table></lead-profile-tab-finance-study-information-table>
			</div> -->

			<!-- Fees Notice Details -->
			<!-- <div class="col-md-12 mt-8">
				<lead-profile-tab-finance-fees-notice-details-table></lead-profile-tab-finance-fees-notice-details-table>
			</div> -->

			<!-- Field text "balance due" readonly on right bottom corner -->
			<!-- <div class="col-md-12 mt-8">
				<div class="row">
					<div class="col-md-6"></div>
					<div class="col-md-6">
						<div class="row">
							<div class="col-md-6"></div>
							<div class="col-md-6">
								<div class="form-group row align-items-center">
									<label
										for="inputs_balance_due"
										class="col-sm-3 mb-0"
									>
										Balance Due
									</label>
									<app-input
										id="inputs_balance_due"
										class="col-sm-9"
										type="text"
										v-model="inputs.balance_due"
										placeholder="Balance Due"
										readonly
										disabled
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div> -->

			<!-- Invoice Process Form -->
			<!-- <div class="col-lg-12">
				<div class="mb-4">
					<h4>Invoice Process</h4>
				</div>
				<form
					ref="form"
					data-url=""
					class="mb-0"
					@submit.prevent="submitInvoiceProcess"
				>
					<div class="row">
						<div class="col-lg-12">
							<div class="row">
								<div class="col-md-3">
									<div class="form-group">
										<label>Reference ID</label>
										<input
											type="text"
											placeholder="Reference ID"
											v-model="
												invoiceProcess.reference_id
											"
											name="reference_id"
											class="form-control"
										/>
									</div>
								</div>
								<div class="col-md-3">
									<div class="form-group">
										<label>CLC ID No</label>
										<input
											type="text"
											placeholder="CLC ID No"
											v-model="invoiceProcess.clc_id_no"
											name="clc_id_no"
											class="form-control"
										/>
									</div>
								</div>
								<div class="col-md-3">
									<div class="form-group">
										<label>Product Name</label>
										<input
											type="text"
											placeholder="Product Name"
											v-model="
												invoiceProcess.product_name
											"
											name="product_name"
											class="form-control"
										/>
									</div>
								</div>
								<div class="col-md-3">
									<div class="form-group">
										<label>Parent Name</label>
										<input
											type="text"
											placeholder="Parent Name"
											v-model="invoiceProcess.parent_name"
											name="parent_name"
											class="form-control"
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-3">
									<div class="form-group">
										<label>Invoice Request No</label>
										<input
											type="text"
											placeholder="Invoice Request No"
											v-model="
												invoiceProcess.invoice_request_no
											"
											name="invoice_request_no"
											class="form-control"
										/>
									</div>
								</div>
								<div class="col-md-3">
									<div class="form-group">
										<label>Name</label>
										<input
											type="text"
											placeholder="Name"
											v-model="invoiceProcess.name"
											name="name"
											class="form-control"
										/>
									</div>
								</div>
								<div class="col-md-3">
									<div class="form-group">
										<label>Class Name</label>
										<input
											type="text"
											placeholder="Class Name"
											v-model="invoiceProcess.class_name"
											name="class_name"
											class="form-control"
										/>
									</div>
								</div>
								<div class="col-md-3">
									<div class="form-group">
										<label>Invoice Sent Via</label>
										<app-input
											placeholder="Invoice Sent Via"
											type="search-select"
											:list="invoice_sent_vias"
											name="invoice_sent_via"
											v-model="
												invoiceProcess.invoice_sent_via
											"
											required
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-3">
									<div class="form-group">
										<label>Fees Notice No</label>
										<input
											type="text"
											placeholder="Fees Notice No"
											v-model="
												invoiceProcess.fees_notice_no
											"
											name="fees_notice_no"
											class="form-control"
										/>
									</div>
								</div>
								<div class="col-md-3"></div>
								<div class="col-md-3">
									<div class="form-group">
										<label>Start Date</label>
										<app-input
											type="date"
											v-model="invoiceProcess.start_date"
											name="start_date"
											placeholder="Start Date"
											required
										/>
									</div>
								</div>
								<div class="col-md-3">
									<div class="form-group">
										<label>Due Date</label>
										<app-input
											type="date"
											v-model="invoiceProcess.due_date"
											name="due_date"
											placeholder="Due Date"
											required
										/>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="mt-5 mb-5 action-buttons">
						<button type="submit" class="btn btn-primary mr-2">
							Submit
						</button>
						<button
							type="button"
							class="btn btn-secondary"
							@click="clearInvoiceProcess"
						>
							Clear
						</button>
					</div>
				</form>
			</div> -->
		</div>
	</div>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import GlobalHelperMixin from "../../../../../../../Mixins/global/GlobalHelperMixin";

export default {
	name: "LeadTabFinance",
	mixins: [FormMixin, GlobalHelperMixin],
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			sameAsAbove: false,
			inputs: {},
			invoiceRequest: {
				reference_id: "",
				request_date: "",
				invoice_send_to: "",
				scheduled_print_date: "",
				invoice_request_no: "",
				requested_by: "",
				invoice_send_via: "",
				invoice_due_date: "",
			},
			invoiceProcess: {
				reference_id: "",
				clc_id_no: "",
				product_name: "",
				parent_name: "",
				invoice_request_no: "",
				name: "",
				class_name: "",
				invoice_sent_via: "",
				fees_notice_no: "",
				start_date: "",
				due_date: "",
			},
			invoice_sent_vias: [
				{ id: "whatsapp", value: "Whatsapp" },
				{ id: "email", value: "Email" },
				{ id: "fax", value: "Fax" },
				{ id: "post", value: "Post" },
				{ id: "other", value: "Other" },
			],
		};
	},
	methods: {
		submitInvoiceRequest() {
			// Logic for submitting Invoice Request form.
			// Access data using this.invoiceRequest.

			// For example, you can log the data to the console:
			console.log("Invoice Request Form:", this.invoiceRequest);

			// You can also make an API request to submit the data if needed.
		},
		clearInvoiceRequest() {
			// Clear Invoice Request form fields.
			for (let key in this.invoiceRequest) {
				this.invoiceRequest[key] = "";
			}
		},
		submitInvoiceProcess() {
			// Logic for submitting Invoice Process form.
			// Access data using this.invoiceProcess.

			// For example, you can log the data to the console:
			console.log("Invoice Process Form:", this.invoiceProcess);

			// You can also make an API Process to submit the data if needed.
		},
		clearInvoiceProcess() {
			// Clear Invoice Process form fields.
			for (let key in this.invoiceProcess) {
				this.invoiceProcess[key] = "";
			}
		},
	},
	watch: {},
};
</script>

<style scoped>
.ml-40 {
	margin-left: 40px; /* You can adjust the margin value as needed */
}
.mt-8 {
	margin-top: 40px;
}
.form-control {
	border: 3px solid; /* You can adjust the border color and width as needed = #c41a1a !important; */
}
.required-star {
	color: red;
}
</style>
